import { render, staticRenderFns } from "./icon-edit.component.vue?vue&type=template&id=10103ff5&scoped=true&"
import script from "./icon-edit.component.vue?vue&type=script&lang=ts&"
export * from "./icon-edit.component.vue?vue&type=script&lang=ts&"
import style0 from "./icon-edit.component.vue?vue&type=style&index=0&id=10103ff5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10103ff5",
  null
  
)

export default component.exports